<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 14 14" :class="[`${prefix}-icon`, `${prefix}-icon-files`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_2a0c4740f1__a"><rect width="14" height="14" rx="0"/></clipPath></defs><g clip-path="url(#svg_2a0c4740f1__a)"><path d="M13.0173,3.06151619140625L6.68663,3.06151619140625L6.34238,1.99376319140625C6.21288,1.58731819140625,5.8354,1.31128273140625,5.40882,1.31109619140625L0.986078,1.31109619140625C0.441482,1.31109632124825,0,1.75257819140625,0,2.29717419140625L0,11.70279619140625C-0.00000110365,12.24739619140625,0.441481,12.68889619140625,0.986078,12.68889619140625L13.0173,12.68889619140625C13.5619,12.68889619140625,14.0034,12.24739619140625,14.0034,11.70279619140625L14.0034,4.0475961914062495C14.0034,3.50299619140625,13.5619,3.06151619140625,13.0173,3.06151619140625ZM0.986077,3.06151619140625L0.986077,2.29717419140625L5.40882,2.29717419140625L5.65388,3.06151619140625L0.986077,3.06151619140625Z"/></g></svg>
</template>
<script>

export default {
  name: 'IconFiles',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
